import { RouteObject } from "react-router-dom"
import LayoutPlain from "app/components/Layout/Plain"
import NotFound from "app/pages/NotFound"
import Error from "app/pages/Error"
import ErrorPhoneVerification from "app/pages/Error-phone-verification"
import NewCarSuccess from "app/pages/NewCarSuccess"

import PreownedSuccess from "app/pages/PreOwnedSuccess"

import LayoutPreOwned from "app/components/Layout/PreOwned"
import LayoutAppflow from "app/components/Layout/Appflow"
import { AppFlowPage } from "app/pages/appFlow"

type Routes = RouteObject & {
  layout?: React.FC
}

const routes: Routes[] = [
  {
    path: "/error",
    element: <Error />
  },
  {
    path: "/error-phone-verification",
    element: <ErrorPhoneVerification />
  },
  {
    path: "/success",
    element: <NewCarSuccess />
  },
  {
    path: "/preowned/success",
    element: <PreownedSuccess />,
    layout: LayoutPreOwned
  },
  {
    path: "/:clientType?/:carType?/:product?/:step?",
    element: <AppFlowPage />,
    layout: LayoutAppflow
  },
  {
    path: "*",
    element: <NotFound />,
    layout: LayoutPlain
  }
]

export default routes
